import { action } from 'satcheljs';

export default action('SET_FIRST_RUN_FAVORITES_MIGRATION_BIT');
